import { useCallback } from "react";

import { useFetch } from "common/utilities/apiFetch";
import { setIsAuthenticatingCookie } from "common/utilities/cookies";
import { writeToLocalStorage } from "common/utilities/localStorage";
import { logger } from "common/utilities/logger";
import { useDispatch } from "common/utilities/react-redux";
import { authenticateSuccess } from "domains/authentication/actions";
import { fetchPermissionsSuccess } from "entities/permissions/actions";
import type { PermissionData } from "entities/permissions/types";

export const useFetchPermissions = () => {
  const dispatch = useDispatch();
  const fetch = useFetch();

  return useCallback(
    (idToken?: string) =>
      fetch("auth/permissions", { idToken, queryParams: { client: "intelligence_web" } })
        .then((response) => response.json())
        .then((body: PermissionData) => {
          writeToLocalStorage("permissions", body);
          dispatch(fetchPermissionsSuccess(body));
          if (idToken === undefined) return;
          dispatch(authenticateSuccess(idToken));
          setIsAuthenticatingCookie(false);
        })
        .catch((error: unknown) => logger.error("[useFetchPermissions] Failed to fetch permissions", error)),
    [dispatch, fetch],
  );
};
